export default "__VITE_ASSET__Br1Lz5OY__"